// Which API this app talks to is set via REACT_APP_SERVER_URL, not by
// commenting/uncommenting lines here. Set it in Web/.env.local (gitignored by
// Create React App by default, never committed) — e.g.:
//   REACT_APP_SERVER_URL=http://localhost:8080/
//   REACT_APP_SERVER_URL=https://stagingknitrino.foundersapproach.com:8080/
// With no .env.local present, this defaults to live — exactly today's
// checked-in behavior, so a normal build is unaffected.
export const SERVER_URL = process.env.REACT_APP_SERVER_URL || "https://knitrino.foundersapproach.com:8080/";
